import { IAnalyticsEvent } from '@r3f-component-data-structure/types/analytics';
import { AnalyticsProvider } from './analyticsProvider';

export class GoogleAnalyticsProvider extends AnalyticsProvider {
	protected _COOKIE_PREFIXES = ['_ga', '_gat', '_gat_*', '_gid', '_ga_*', '_gac_*', '__utma', '__utmt', '__utmb', '__utmc', '__utmz', '__utmv', 'AMP_TOKEN'];

	constructor(propertyIds?: string[]) {
		super(propertyIds);
	}

	init(propertyIds: string[]): void {
		for (let i = 0; i < propertyIds.length; i++) {
			const headNode = document.getElementsByTagName('head')[0];

			const gTagScript = document.createElement('script');
			gTagScript.async = true;
			gTagScript.src = `https://www.googletagmanager.com/gtag/js?id=${propertyIds[i]}`;
			headNode.parentElement?.insertBefore(gTagScript, headNode.nextSibling);

			const gTagScript2 = document.createElement('script');
			gTagScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${propertyIds[i]}');`;
			headNode.parentElement?.insertBefore(gTagScript2, headNode.nextSibling);
			console.log('Google Analytics loaded');
		}
	}

	updateCookieConsent(granted: boolean): void {
		const consentValue = granted ? 'granted' : 'denied';
		gtag('consent', 'update', { ad_storage: consentValue, analytics_storage: consentValue });
		if (!granted) {
			this._removeCookies();
		}
	}

	sendEvent(event: IAnalyticsEvent): void {
		console.log('Send GA event');
		gtag('event', event.name, {
			event_category: event.category,
			event_label: event.label,
			value: event.value,
		});
	}
}
